import { ApiProperty } from '@nestjs/swagger';
import { IsDateString, IsNotEmpty, IsNumber, IsUUID, Min } from 'class-validator';

export class CreateCotizacionDto {
  @ApiProperty({ example: 'uuid-moneda', description: 'ID de la moneda' })
  @IsNotEmpty()
  @IsUUID()
  moneda_id: string;

  @ApiProperty({ example: '2024-01-20', description: 'Fecha de la cotización' })
  @IsNotEmpty()
  @IsDateString()
  fecha: string;

  @ApiProperty({ example: 7300, description: 'Cotización de compra' })
  @IsNotEmpty()
  @IsNumber()
  @Min(0)
  cotizacion_compra: number;

  @ApiProperty({ example: 7400, description: 'Cotización de venta' })
  @IsNotEmpty()
  @IsNumber()
  @Min(0)
  cotizacion_venta: number;
}
